import axios from 'axios';

import { HttpApiClient } from './HttpApiClient';
export const getCountry = async () => {
	return HttpApiClient.get('https://ipinfo.io/json')
		.then((res) => res.json());
};

export const checkSession = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/currencyType`, {
		Authorization: `Bearer ${token}`,
	})
		.then((res) => res.json())
		.catch((e) => 'checkSessionFailed');
};

export const loginArk = async (arkbaseurl: string | undefined, credential: any) => {
	return HttpApiClient.post(
		`${arkbaseurl}/login/api/v2/login`,
		{ 'Content-Type': 'application/json' },
		credential,
		true,
	)
		.then((res) => res.json())
		.catch((e) => {
			console.error(e);
			return 'login Failed';
		});
};

export const getJournalDetails = async (arkbaseurl: string | undefined, id:string,token: string | undefined) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/journal/${id}`,
		{ Authorization: `Bearer ${token}` }
	)
	.then((res)=>res.json())
	.catch((e) => {
			console.error(e);
			return 'journal fetch failed';
	});
}
export const loginMfa = async (
	arkbaseurl: string | undefined,
	credential: any,
	otp: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkbaseurl}/login/api/v2/verifyOTP?code=${otp}`,
		{ 'Content-Type': 'application/json' },
		credential,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'mfa login failed');
};

export const verifyOTP = async (arkbaseurl: string | undefined, data: any) => {
	return HttpApiClient.put(
		`${arkbaseurl}/login/api/v2/verify/user`,
		{ 'Content-Type': 'application/json' },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'verify OTP failed');
};

export const forgetPassword= async (arkbaseurl: string | undefined, username: any) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/user/forgotPassword/username?username=${username}`,
		{ 'Content-Type': 'application/json' },
	).then((res) => res.json());
};

export const resendOtp = async (arkbaseurl: string | undefined, username:string,OtpMessageType:number) => {
	return HttpApiClient.post(`${arkbaseurl}/admin/api/v2/messageProvider/resend/${username}/${OtpMessageType}`, {
		'Content-Type': 'application/json',
	},undefined,true)
		.then((res) => res.json())
		.catch((e) => 'resend OTP failed');
};

export const logoutArk = async (arkbaseurl: string | undefined, token: string | null) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/login/api/v2/logout`,
		{ Authorization: `Bearer ${token}` },
		undefined,
		true,
	).then((res) => res.json());
};
export const getbranchs = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/branch`, {
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};
export const getBanks = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/bank`, {
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getUserByUsername = async (
	username: string | undefined,
	crmbaseurl: string | undefined,
) => {
	return HttpApiClient.get(
		`${crmbaseurl}/getUserbyUserName?username=${username}`,
		undefined,
	).then((res) => res.json());
};

export const createArkUser = async (data: any, arkbaseurl: string | undefined, token: any) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/user`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'Unable To Create User.');
};

export const UpdateArkUser = async (data:any,userId:number, arkbaseurl:string | undefined, token:any) =>{
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/user/${userId}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true
	)
		.then(res => res.json())
		.catch(e=>'Unable to Update User.')
}

export const getGenericPolicy = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
	userType: Number | undefined,
	withDetail: Boolean | false,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/dealer/policy/${userType}?withDetail=${withDetail}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	).then((res) => res.json());
};

export const getAgentCommissionPolicy = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/agentCommissionPolicy`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getAllCurrencyPoliciesByUserType = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
	userType: number,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/currency/policy/${userType}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const createAccountArk = async (data: any, arkbaseurl: string | undefined) => {
	return HttpApiClient.post(
		`${arkbaseurl}/login/api/v2/signup/real`,
		{ 'Content-Type': 'application/json' },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'mfa login failed');
};

export const createAccountDemoArk = async (data: any, arkbaseurl: string | undefined) => {
	return HttpApiClient.post(
		`${arkbaseurl}/login/api/v2/signup`,
		{ 'Content-Type': 'application/json' },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'mfa login failed');
};

export const createAccountStep1 = async (crmbaseurl: string | undefined, data: any) => {
	return axios.post(`${crmbaseurl}/create-account-step1`, data);
};

export const createAccountStep2 = async (crmbaseurl: string | undefined, data: any) => {
	return axios.post(`${crmbaseurl}/create-account-step2`, data);
};

export const createAccountStep3 = async (crmbaseurl: string | undefined, data: any) => {
	return axios.post(`${crmbaseurl}/create-account-step3`, data);
};

export const uploadDocuments = async (crmbaseurl: string | undefined, formData: FormData) => {
	return axios
		.post(`${crmbaseurl}/documents`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		.then((res) => res);
};

export const getDocumentStatus = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(
		`${crmbaseurl}/getdocumentstatus?username=${username}`,
		undefined,
	).then((res) => res.json());
};

export const getAccountSummary = async (
	arkbaseurl: string | undefined,
	userId: Number | undefined,
	token: any,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/financialStandings/api/v2/userFinancials/${userId}?withtotal=true`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	).then((res) => res.json());
};

export const changePassword = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/user/profile`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const getTrasactionHistory = async (
	arkbaseurl: string | undefined,
	id: Number,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/trading/api/v2/user/${id}/history?fromDate=${start}&toDate=${end}&withOpen=true`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'failed');
};

export const withdraw = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.post(
		`${arkbaseurl}/trading/api/v2/cashRequest`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};
export const deposit = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.post(
		`${arkbaseurl}/trading/api/v2/depositRequest`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => {
			console.log('errrr=', e);
			return 'failed to create deposit request';
		});
};

export const getDepositRequests = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/trading/api/v2/depositRequest/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};
export const depositUpdate = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.put(
		`${arkbaseurl}/trading/api/v2/depositRequest`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};
export const DepositDelete = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/trading/api/v2/depositRequest`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const withdrawUpdate = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.put(
		`${arkbaseurl}/trading/api/v2/cashRequest`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const withdrawDelete = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/trading/api/v2/cashRequest`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const loan = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/creditLoan`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const loanUpdate = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/creditLoan`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const loanDelete = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/admin/api/v2/creditLoan`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const transfermoney = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/money/transaction`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const transferposition = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string,
) => {
	return HttpApiClient.put(
		`${arkbaseurl}/trading/api/v2/trading/transfer/position`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const getWithdrawRequests = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/trading/api/v2/cashRequest/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getMailList = async (
	arkbaseurl: string | undefined,
	startDate: string | undefined,
	endDate: string | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/email?fromDate=${startDate}&toDate=${endDate}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	).then((res) => res.json());
};
export const getMailBodyById = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/email/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};
export const deleteMailById = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/admin/api/v2/email`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const getLoanRequests = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/creditLoan/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const logChangePassword = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/logchangepassword?username=${username}`, {}).then(
		(res) => res.json(),
	);
};

export const logWithdraw = async (crmbaseurl: string | undefined, username: string | undefined) => {
	return HttpApiClient.get(`${crmbaseurl}/logwithdraw?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

export const logWithdrawUpdate = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/logwithdrawupdate?username=${username}`, {}).then(
		(res) => res.json(),
	);
};

export const logWithdrawDelete = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/logwithdrawdelete?username=${username}`, {}).then(
		(res) => res.json(),
	);
};

export const logLoan = async (crmbaseurl: string | undefined, username: string | undefined) => {
	return HttpApiClient.get(`${crmbaseurl}/logloan?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

export const logLoanUpdate = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/logloanupdate?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

export const logLoanDelete = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/logloandelete?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

export const logTransferMoney = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/logtransfermoney?username=${username}`, {}).then(
		(res) => res.json(),
	);
};

export const getRecentActivitiesByTime = async (
	arkbaseurl: string | undefined,
	userId: Number | undefined,
	start: string,
	end: string,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/activity/report/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	).then((res) => res.json());
};

export const sendToEmail = async (arkbaseurl: string | undefined, email: string) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/user/forgotPassword?email=${email}`,
		{},
	).then((res) => res.json());
};

export const resetPassword = async (arkbaseurl: string | undefined, data: any) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/user/resetPassword`,
		{ 'Content-Type': 'application/json' },
		data,
		true,
	).then((res) => res.json());
};

export const createDemoAccount = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkbaseurl}/login/api/v2/signup`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

///////////////////////////////////admin/////////////////////////////

export const getProfileInfo = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/user/profileInfo`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};
export const getUser = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/user`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getUserById = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
	userId: Number | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/user/${userId}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};
export const getPermissionByGnericPolicy = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
	policy: Number | undefined,
	userType: Number | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/dealer/policy/${userType}/${policy}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getCurrencyPolicyDetails = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
	policyId: Number | undefined,
	userId: Number | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/currency/policy/${policyId}/${userId}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getUsers = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/user`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const getUsersFromCRM = async (crmbaseurl: string | undefined) => {
	return HttpApiClient.get(`${crmbaseurl}/getusers`, {}).then((res) => res.json());
};

export const getCurrencies = async (arkbaseurl: string | undefined, token: string | undefined) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/currency`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const moneyTransaction = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/money/transaction`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};
export const getAdminDepositRequests = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/trading/api/v2/depositRequest/pending/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};
export const rejectandacceptDepositRequests = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkbaseurl}/trading/api/v2/depositRequest/handle`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const getAdminWithdrawRequests = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/cashDelivery/pending/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const rejectandacceptWithdrawRequests = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/cashDelivery`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const acceptWithdrawRequests = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/cashDelivery/accept`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const getAdminLoanRequests = async (
	arkbaseurl: string | undefined,
	id: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/creditLoan/pending/${id}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	}).then((res) => res.json());
};

export const acceptLoan = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/creditLoan/accept`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const partialAcceptLoan = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/creditLoan/accept/partially`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const rejectLoan = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/creditLoan/reject`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	).then((res) => res.json());
};

export const getTransactionReports = async (
	arkbaseurl: string | undefined,
	userId: String,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/user/${userId}/transactionLogs?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getMoneyTransactionReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/money/transaction/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getUsersDetailsReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	includeTransfers: boolean,
	token: string,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/report/users/details/${userId}?includeTransfers=${includeTransfers}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	})
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getUsersDetailsReportsWithDate = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	includeTransfers: boolean,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/users/details/${userId}?fromDate=${start}&toDate=${end}&includeTransfers=${includeTransfers}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getTodaysNewDepositRequests = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	withDemo: boolean,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/users/details/firstDeposit/${userId}?fromDate=${start}&toDate=${end}&withDemo=${withDemo}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getTodaysREDepositRequests = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	withDemo: boolean,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/users/details/reDeposit/${userId}?fromDate=${start}&toDate=${end}&withDemo=${withDemo}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getTodaysLiquidateAccountRequests = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	withDemo: boolean,
	token: string,
	onlyZeroBalance = false,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/users/details/liquidate/${userId}?fromDate=${start}&toDate=${end}&withDemo=${withDemo}&onlyZeroBalance=${onlyZeroBalance}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getInactiveAccountsWithFunds = async (
	arkbaseurl: string | undefined,
	userId: string,
	withDemo: boolean,
	withBalance: boolean,
	lastActivityDays: number,
	token: string,
	signal?: AbortSignal,
): Promise<any> => {
	try {
		const response = await HttpApiClient.get(
			`${arkbaseurl}/financialStandings/api/v2/report/users/details/inActive/${userId}?withDemo=${withDemo}&withBalance=${withBalance}&lastActivityDays=${lastActivityDays}`,
			{
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			{ signal },
		);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		return await response.json();
	} catch (error) {
		if ((error as Error).name === 'AbortError') {
			console.log('Fetch aborted');
			return null; // ✅ Return null to indicate aborted request
		}
		console.error('Error fetching data:', error);
		return 'sessionExpired';
	}
};
export const getActiveAccountsWithFunds = async (
	arkbaseurl: string | undefined,
	userId: string,
	withDemo: boolean,
	withBalance: boolean,
	lastActivityDays: number,
	token: string,
	signal?: AbortSignal,
): Promise<any> => {
	try {
		const response = await HttpApiClient.get(
			`${arkbaseurl}/financialStandings/api/v2/report/users/details/active/${userId}?withDemo=${withDemo}&withBalance=${withBalance}&lastActivityDays=${lastActivityDays}`,
			{
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			{ signal },
		);

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		return await response.json();
	} catch (error) {
		if ((error as Error).name === 'AbortError') {
			console.log('Fetch aborted');
			return null; // ✅ Return null to indicate aborted request
		}
		console.error('Error fetching data:', error);
		return 'sessionExpired';
	}
};

export const getTopXWinnersAndLoosers = async (
	arkbaseurl: string | undefined,
	winners: Boolean,
	withDemo: Boolean,
	X: number,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/closeProfit/report?winners=${winners}&withDemo=${withDemo}&limit=${X}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getdealers = async (arkbaseurl: string | undefined,dealerTreeId:String,token: string) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/users/details/${dealerTreeId}?userTypeId=3`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');


}
export const getAccountsWithoutMoneyTransc = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	withDemo: boolean,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/users/details/noMoneyTrx/${userId}?fromDate=${start}&toDate=${end}&withDemo=${withDemo}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getOpenPositions = async (
	arkbaseurl: string | undefined,
	userId: Number | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/trading/api/v2/trading/${userId}`, {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${token}`,
	})
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getDetailedOpenPositionsReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	posType: Number,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/trading/api/v2/report/open/positions/${userId}/${posType}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getDetailedOpenHistoryReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	posType: Number,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/open/history/report/${userId}/${posType}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getDetailedCloseHistoryReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	posType: Number,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/closed/positions/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getPendingOrdersReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	orderType: Number,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/orders/${userId}/${orderType}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getDetailedFinancialStandingReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	withDemo: boolean,
	withTotals: boolean,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/financialStandings/api/v2/report/finance?userIds=${userId}&withDemo=${withDemo}&withTotals=${withTotals}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getFinancialStandingHistoryReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/financialStandings/api/v2/report/fs/history/${userId}?fromDate=${start}&toDate=${end}`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getLoginReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
	deviceType: string | undefined,
	macAddress: string | undefined,
) => {
	let filter = '';
	if (deviceType) {
		filter += `&deviceType=${deviceType}`;
	}
	if (macAddress) {
		filter += `&macAddress=${macAddress}`;
	}
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/login/history/${userId}?fromDate=${start}&toDate=${end}${filter}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getOpenRoboOrdersHistoryReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/pending/open/positions/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getCloseRoboOrdersHistoryReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/pending/closed/positions/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};
export const getDepositRequestsReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/deposit/report/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getWithdrawRequestsReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/cashRequest/report/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getLoanRequestsReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/creditLoan/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const getJournalReports = async (
	arkbaseurl: string | undefined,
	userId: string,
	start: string,
	end: string,
	token: string,
) => {
	return HttpApiClient.get(
		`${arkbaseurl}/admin/api/v2/report/journal/report/${userId}?fromDate=${start}&toDate=${end}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const changeArkUser = async (
	arkbaseurl: string | undefined,
	data: any,
	userId: string,
	token: string,
) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/user/${userId}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};


export const announceNote = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/announceNote`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const sendMail = async (
	arkbaseurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/email`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const disconnect = async (arkbaseurl: string | undefined, userId: string, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/admin/api/v2/user/disconnect/user/${userId}`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		undefined,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const hardDelete = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/admin/api/v2/user`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const CreateBank = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.post(
		`${arkbaseurl}/admin/api/v2/bank`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((res) => 'failed to create bank');
};
export const UpdateBank = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.put(
		`${arkbaseurl}/admin/api/v2/bank`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((res) => 'failed to update bank');
};
export const DeleteBank = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/admin/api/v2/bank`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((res) => 'failed to delete bank');
};
export const DeleteBanks = async (arkbaseurl: string | undefined, data: any, token: string) => {
	return HttpApiClient.delete(
		`${arkbaseurl}/admin/api/v2/bank`,
		{ 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		data,
		true,
	)
		.then((res) => res.json())
		.catch((res) => 'failed to delete bank');
};

export const getPendingKYC = async (crmbaseurl: string | undefined) => {
	return HttpApiClient.get(`${crmbaseurl}/getpendingkyc`, {})
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const approveKYC = async (
	crmbaseurl: string | undefined,
	adminUsername: string,
	username: string,
) => {
	return HttpApiClient.get(
		`${crmbaseurl}/approvekyc?admin=${adminUsername}&username=${username}`,
		{},
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const rejectKYC = async (
	crmbaseurl: string | undefined,
	adminUsername: string,
	username: string,
) => {
	return HttpApiClient.get(
		`${crmbaseurl}/rejectkyc?admin=${adminUsername}&username=${username}`,
		{},
	)
		.then((res) => res.json())
		.catch((e) => 'sessionExpired');
};

export const logSignIn = async (crmbaseurl: string | undefined, username: string | undefined) => {
	return HttpApiClient.get(`${crmbaseurl}/logsignin?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

export const logSignOut = async (crmbaseurl: string | undefined, username: string | undefined) => {
	return HttpApiClient.get(`${crmbaseurl}/logsignout?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

export const getImageUrls = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/getimageurls?username=${username}`, {}).then((res) =>
		res.json(),
	);
};

//ai and news section
export const getNews = async (mobileauthurl: string | undefined) => {
	return HttpApiClient.get(`${mobileauthurl}/news/ai`, {
		'Content-Type': 'application/json',
	}).then((res) => res.json());
};

export const checkCrmUser = async (
	crmbaseurl: string | undefined,
	username: string | undefined,
) => {
	return HttpApiClient.get(`${crmbaseurl}/checkcrmuser?username=${username}`, {}).then((res) =>
		res.json(),
	);
};





export const GetOtpMessageList = async (
	arkbaseurl: string | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(`${arkbaseurl}/admin/api/v2/messageProvider`,
		{
				accept: 'application/json',
				'content-type': 'application/json',
				Authorization: `Bearer ${token}`,
			}

	)
	.then((res) => res.json())
	.catch((e) => 'Get Message Provider Failed');
	
};


export const updateMessageCred = async (
	arkbaseurl: string | undefined,
	body: object,
	token: string | undefined,
) => {
	try {
		const response = await HttpApiClient.put(
			`${arkbaseurl}/admin/api/v2/messageProvider`,
			{
				accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body,
			true,
		);

		if (response.ok) {
			return await response.json();
		} else {
			throw new Error('Message Cred update Failed');
		}
	} catch (error) {
		return { success: false, message: 'Message Cred update Failed' };
	}
};

export const createAccountLog = async (mobileAuthUrl: string | undefined, data: any) => {
	try {
		const response = await HttpApiClient.post(
			`${mobileAuthUrl}/api/common/logs/createAccount`,
			{
				accept: 'application/json',
				'content-type': 'application/json',
			},
			data,
			false,
		);
		return await response.json();
	} catch {
		return { success: false, message: 'Create Account Log Failed' };
	}
};

export const getCreateAccountLogs = async (
	mobileAuthUrl: string | undefined,
	query: String,
	orgId: string,
	userId: string,
	token: string | undefined,
) => {
	try {
		const response = await HttpApiClient.get(
			`${mobileAuthUrl}/api/admin/logs/createAccount${query}`,
			{
				accept: 'application/json',
				'content-type': 'application/json',
				Authorization: `Bearer ${token}`,
				'x-org-id': orgId,
				'x-user-id': userId,
			},
		);
		return await response.json();
	} catch {
		return { success: false, message: 'Unable To Fetch Create Account Logs' };
	}
};
export const deleteCreateAccountLogs = async (
	mobileAuthUrl: string | undefined,
	id: string,
	orgId: string,
	userId: string,
	token: string | undefined,
) => {
	try {
		const response = await HttpApiClient.delete(
			`${mobileAuthUrl}/api/admin/logs/createAccount/${id}`,
			{
				accept: 'application/json',
				'content-type': 'application/json',
				Authorization: `Bearer ${token}`,
				'x-org-id': orgId,
				'x-user-id': userId,
			},
			undefined,
			false,
		);
		return await response.json();
	} catch {
		return { success: false, message: 'Unable To Delete Create Account Logs' };
	}
};

// education center

export const getEducationCenterVideos = async (arkapiurl: string | undefined, token: string | undefined) => {
    return HttpApiClient.get(
        `${arkapiurl}/admin/api/v2/playlist`,
        {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    ).then(res => res.json())
    .catch(err=>{
        console.log("err",err)
        return {status:false,message:err.message}
    })
}
export const addEducationCenterVideo= async (arkapiurl: string | undefined, data: any, token: string | undefined) => {
    return HttpApiClient.post(
        `${arkapiurl}/admin/api/v2/playlist`,
        {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        data
    ).then(res => res.json())
    .catch(err=>{
        console.log("err",err)
        return {status:false,message:err.message}
    })
}

export const updateEducationCenterVideo= async (arkapiurl: string | undefined, data: any,token:string | undefined) => {
    return HttpApiClient.put(
        `${arkapiurl}/admin/api/v2/playlist/`,
        {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        data
    ).then(res => res.json())
    .catch(err=>{
        console.log("err",err)
        return {status:false,message:err.message}
    })
}

export const deleteEducationCenterVideo= async (arkapiurl: string | undefined, body:any,token:string | undefined) => {
    return HttpApiClient.delete(
        `${arkapiurl}/admin/api/v2/playlist`,
        {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            
        },
        body
    ).then(res => res.json()).catch(err=>{
        console.log("err",err)
        return {status:false,message:err.message}
    })
}


export const getPublicSettings = async (
	arkapiurl: string | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkapiurl}/admin/api/v2/publicSettings`,
		{
			accept: 'application/json',
			'content-type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};


// configuration
export const getConfiguration = async (
	arkapiurl: string | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkapiurl}/admin/api/v2/publicSettings`,
		{
			accept: 'application/json',
			'content-type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};


export const updateConfiguration = async (
	mobileauthurl: string | undefined,
	orgId: string | undefined,
	userId: Number | undefined,
	token: string | undefined,
	data: any,
) => {
	return HttpApiClient.put(
		`${mobileauthurl}/api/admin/configurations`,
		{
			accept: 'application/json',
			'content-type': 'application/json',
			'x-org-id': orgId ?? '',
			'x-user-id': userId?.toString() ?? '',
			Authorization: `Bearer ${token ?? ''}`,
		},
		data,
		false,
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};


// leads services
export const getLeads = async (
	arkapiurl: string | undefined,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkapiurl}/admin/api/v2/leads`,
		{
			accept: 'application/json',
			'content-type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
};

export const createLead = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkapiurl}/admin/api/v2/leads`,
		{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
		data
		)
		.then((res) => res.json())
		.catch((err) => {	
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}	

export const updateLead = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkapiurl}/admin/api/v2/leads/`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data,
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};

export const deleteLead = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.delete(
		`${arkapiurl}/admin/api/v2/leads/`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data,
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};

export const getLeadRemarks = async (
	arkapiurl: string | undefined,
	leadId: number,
	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkapiurl}/admin/api/v2/leads/${leadId}/remarks`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}
export const createLeadRemark = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkapiurl}/admin/api/v2/leads/remarks`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};
export const updateLeadRemark = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkapiurl}/admin/api/v2/leads/remarks/`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const deleteLeadRemarks = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.delete(
		`${arkapiurl}/admin/api/v2/leads/remarks/`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		});
};


export const getLeadAssignments = async (
	arkapiurl: string | undefined,
	token: string | undefined
) => {
	return HttpApiClient.get(
		`${arkapiurl}/admin/api/v2/lead-assignments`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const createLeadAssignment = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.post(
		`${arkapiurl}/admin/api/v2/lead-assignments`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())	
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const updateLeadAssignment = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkapiurl}/admin/api/v2/lead-assignments`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())	
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const deleteLeadAssignment = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.delete(
		`${arkapiurl}/admin/api/v2/lead-assignments`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())	
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

// click to call services
export const getAgentMappings = async (
	arkapiurl: string | undefined,

	token: string | undefined,
) => {
	return HttpApiClient.get(
		`${arkapiurl}/admin/api/v2/clickToCall/agent-mappings`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
};

export const updateAgentMapping = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.put(
		`${arkapiurl}/admin/api/v2/clickToCall/agent-mappings`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const deleteAgentMapping = async (
	arkapiurl: string | undefined,
	data: any,
	token: string | undefined,
) => {
	return HttpApiClient.delete(
		`${arkapiurl}/admin/api/v2/clickToCall/agent-mappings`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data
	)
		.then((res) => res.json())
		.catch((err) => {	
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const callLead = async (
	arkapiurl: string | undefined,
	leadId: number,
	token: string | undefined
) => {
	return HttpApiClient.post(
		`${arkapiurl}/admin/api/v2/clickToCall/lead/${leadId}`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		}
		,undefined,true
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}

export const callUser = async (
	arkapiurl: string | undefined,
	userId: number,
	token: string | undefined
) => {
	return HttpApiClient.post(
		`${arkapiurl}/admin/api/v2/clickToCall/user/${userId}`,
		{
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		}
		,undefined,true
	)
		.then((res) => res.json())
		.catch((err) => {
			console.log('err', err);
			return { status: false, message: err.message };
		}
	);
}
